<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">{{ data.cancelText }}</button>
  <button mat-button (click)="onConfirm()">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
